export enum ActionType {
  BUTTON = 'button',
  CONTACT = 'contact',
}
